import { Box, Grid, GridItem, position } from "@chakra-ui/react";
import JackpotItem from "./components/JackpotItem";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";

const JackpotList = ({ fixed }) => {
  const fixedStyle = fixed
    ? {
        width: "-webkit-fill-available",
        bottom: "0px",
        position: "fixed",
      }
    : {};

  const isLandScapeMachine = useIsLandScapeMachine();

  return (
    <Grid
      {...fixedStyle}
      display={{
        base: isLandScapeMachine ? "grid" : "none",
        md: "grid",
      }}
      templateColumns="repeat(5, 1fr)"
    >
      <GridItem>
        <JackpotItem
          fontSize={{
            sm: "24px",
            md: "32px",
          }}
          wrapperH={{
            sm: "16.5px",
            md: "24.5px",
          }}
          wrapperW={{
            sm: "15.5px",
            md: "20px",
            xl: "23px",
          }}
          pb="41px"
          w="100%"
          h={{
            sm: "75px",
            xl: "100px",
          }}
          type="Grand"
        />
      </GridItem>{" "}
      <GridItem>
        <JackpotItem
          fontSize={{
            sm: "24px",
            md: "32px",
          }}
          wrapperH={{
            sm: "16.5px",
            md: "24.5px",
          }}
          wrapperW={{
            sm: "15.5px",
            md: "20px",
            xl: "23px",
          }}
          pb="41px"
          w="100%"
          h={{
            sm: "75px",
            xl: "100px",
          }}
          type="Major"
        />{" "}
      </GridItem>
      <GridItem>
        <JackpotItem
          fontSize={{
            sm: "24px",
            md: "32px",
          }}
          wrapperH={{
            sm: "16.5px",
            md: "28.5px",
          }}
          wrapperW={{
            sm: "15.5px",
            xl: "23px",
          }}
          pb="41px"
          w="100%"
          h={{
            sm: "75px",
            xl: "100px",
          }}
          type="Mega"
        />{" "}
      </GridItem>
      <GridItem>
        <JackpotItem
          fontSize={{
            sm: "24px",
            md: "32px",
          }}
          wrapperH={{
            sm: "16.5px",
            md: "24.5px",
          }}
          wrapperW={{
            sm: "15.5px",
            md: "20px",
            xl: "23px",
          }}
          pb="41px"
          w="100%"
          h={{
            sm: "75px",
            xl: "100px",
          }}
          type="Mini"
        />{" "}
      </GridItem>
      <GridItem>
        <JackpotItem
          fontSize={{
            sm: "24px",
            md: "32px",
          }}
          wrapperH={{
            sm: "16.5px",
            md: "24.5px",
          }}
          wrapperW={{
            sm: "15.5px",
            md: "20px",
            xl: "23px",
          }}
          pb="41px"
          w="100%"
          h={{
            sm: "75px",
            xl: "100px",
          }}
          type="Minor"
        />{" "}
      </GridItem>
    </Grid>
  );
};

export default JackpotList;
